export const SupportTicketsSharedRoutes = [
    {
        path: `/support_tickets/search`,
        name: 'SupportTicketsSearchView',
        component: () => import(
        /* webpackChunkName: "SupportTicketRoutes" */ '../views/SupportTicketsSearchView/SupportTicketsSearchView.vue'),
        meta: {
            displayName: 'COSMIC - Support ticket search',
            description: 'COSMIC Support ticket search',
            supportContexts: [],
            permissions: [],
            userRoles: []
        }
    },
    {
        path: `/support_tickets/manage/:id`,
        name: 'SupportTicketManageView',
        component: () => import(
        /* webpackChunkName: "SupportTicketRoutes" */ '../views/SupportTicketManageView/SupportTicketManageView.vue'),
        meta: {
            displayName: 'COSMIC - Support ticket manage',
            description: 'COSMIC Support ticket manage',
            supportContexts: [],
            permissions: [],
            userRoles: []
        }
    }
];
